import { PRODUCT_MAP } from "./products";
import { allocate } from "./allocate";

export const orderWeight = (lines) => lines.reduce((a, l) => a + l.gallons * PRODUCT_MAP[l.product].lbsPerGal, 0);

export const grossWeight = (trailer, lines) => trailer.tare_weight + orderWeight(lines);

// Take gallons off the last lines (100 gal at a time) until gross is at or under the limit.
export function trimToLegal(trailer, lines) {
  const out = lines.map((l) => ({ ...l }));
  const removed = [];
  for (let i = out.length - 1; i >= 0 && grossWeight(trailer, out) > trailer.max_gross; i--) {
    const before = out[i].gallons;
    while (out[i].gallons > 0 && grossWeight(trailer, out) > trailer.max_gross) out[i].gallons = Math.max(0, Math.floor((out[i].gallons - 1) / 100) * 100);
    if (before !== out[i].gallons) removed.push({ key: out[i].key, product: out[i].product, label: out[i].label, gallons: before - out[i].gallons });
  }
  return { lines: out, removed };
}

const unmet = (trailer, lines, opts) => allocate(trailer.compartments, lines, opts).shortfalls.reduce((a, s) => a + s.gallons, 0);

// Most gallons (in 100s) for one line that stays legal on gross weight and still fits the pocket plan.
export const fullLoadGallons = (key, lines, trailer, activeShell, opts) => {
  const withG = (g) => lines.map((l) => (l.key === key ? { ...l, gallons: g } : l));
  const others = withG(0);
  const p = PRODUCT_MAP[lines.find((l) => l.key === key).product];
  const byWeight = (trailer.max_gross - grossWeight(trailer, others)) / p.lbsPerGal;
  const bySpace = activeShell - others.reduce((a, l) => a + l.gallons, 0);
  let hi = Math.max(0, Math.floor(Math.min(byWeight, bySpace) / 100));
  const base = unmet(trailer, others, opts);
  let lo = 0;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (unmet(trailer, withG(mid * 100), opts) <= base) lo = mid;
    else hi = mid - 1;
  }
  return lo * 100;
};
